// extracted by mini-css-extract-plugin
export default {"geolocation-request":"GeolocationModal_geolocation-request__iP3oA"};